<script setup lang="ts">
export interface BoxProps {
    label: string
    value: string
    link: string
    size: string
}

const props = defineProps<BoxProps>()
const { data, sendEvent } = useTracker()

const handleClick = (): void => {
    sendEvent({
        data: {
            ...data,
            click: props.link,
            title: props.label,
        },
    })
}
</script>
<template>
  <div class="d-flex flex-shrink-0">
    <div>
      <div class="d-flex align-items-center mb-1 mb-md-0 wrap">
        <div class="flex-shrink-0 me-3 d-none d-md-block">
          <slot name="icon-desktop" />
        </div>
        <div>
          <div class="mb-0 d-flex align-items-center text-black">
            <span class="me-2 d-md-none">
              <slot name="icon-mobile" />
            </span>
            {{ props.label }}
          </div>
          <a
            class="text-decoration-none text-black mb-0 d-flex align-items-center text-hover-secondary"
            :class="{
              'gamma mt-2': props.size === 'big',
              'delta mt-1': props.size === 'normal',
            }"
            :href="props.link"
            @click="handleClick"
          >
            {{ props.value }}
            <slot name="icon-link" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import './IconText.scss';
</style>
